<template>
  <!-- 条件筛选区域 -->
  <div class="h-search-view">

    <div class="h-search-base" :style="{height:height+'px',padding:padding+'px','background-color':backgroundColor}">
      <template v-for="(item, index) in data">
        <el-input placeholder="请输入内容" v-model="input3" class="h-search-item" :key="index">
          <el-select v-model="select" slot="prepend" placeholder="请选择">
            <el-option label="餐厅名" value="1"></el-option>
            <el-option label="订单号" value="2"></el-option>
            <el-option label="用户电话" value="3"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </template>
    </div>
    <!-- <div class="" :style="{height:height+'px',padding:padding+'px','background-color':backgroundColor}">2</div> -->
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      }
    },
    height: {
      type: Number || String,
      default: 100
    },
    padding: {
      type: Number || String,
      default: 20
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    }

  },
  data () {
    return {
      input3: '',
      select: 1,
    }
  },
  methods: {

  },
}
</script>
<style lang="stylus" scoped>
.h-search-view
  display flex
  flex-direction column
  .h-search-base
    width 100%
    display flex
    flex-direction row
    align-items center
  .h-search-item
    width 200px
</style>



// WEBPACK FOOTER //
// src/components/parts/hSearch.vue